import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { useClientId } from '../../_hooks/useClientId';
import { queryKeys } from './queryKeys';

interface PulseCheckCardDTO {
  IsCompleted: boolean;
  TopPriorities: string[];
}

interface FetcherParams {
  clientId: number;
}

const fetchPulseCheckCard = async ({ clientId }: FetcherParams): Promise<PulseCheckCardDTO> => {
  const { PulseCheckGoal } = await authFetch(
    urlWithParams('/Consumer/PulseCheckGoals/GoalStatus', { clientId }),
  );

  return PulseCheckGoal;
};

export const usePulseCheckCardQuery = () => {
  const clientId = useClientId();

  return useQuery(
    queryKeys.pulseCheckCard(clientId),

    () => fetchPulseCheckCard({ clientId }),

    {
      cacheTime: 0,
    },
  );
};
